var _circle, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoOn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    className: "{className} ",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9,
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.6
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "11,9 16,12 11,15",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1.4,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoOn);
export default __webpack_public_path__ + "static/media/videoOn.3b934e831a197765c507ef2d00386e91.svg";
export { ForwardRef as ReactComponent };